export default __webpack_public_path__ + "static/media/darkSwapCard.ef4a604d.png";